/* eslint-disable no-tabs */
const IconTrashSvg = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6668 10.6668C10.6668 11.0335 10.3668 11.3335 10.0002 11.3335C9.6335 11.3335 9.3335 11.0335 9.3335 10.6668V8.00016C9.3335 7.6335 9.6335 7.3335 10.0002 7.3335C10.3668 7.3335 10.6668 7.6335 10.6668 8.00016V10.6668ZM6.66683 2.8855C6.66683 2.78216 6.8095 2.66683 7.00016 2.66683H9.00016C9.19083 2.66683 9.3335 2.78216 9.3335 2.8855V4.00016H6.66683V2.8855ZM6.66683 10.6668C6.66683 11.0335 6.36683 11.3335 6.00016 11.3335C5.6335 11.3335 5.3335 11.0335 5.3335 10.6668V8.00016C5.3335 7.6335 5.6335 7.3335 6.00016 7.3335C6.36683 7.3335 6.66683 7.6335 6.66683 8.00016V10.6668ZM14.0002 4.00016H13.3335H10.6668V2.8855C10.6668 2.0295 9.9195 1.3335 9.00016 1.3335H7.00016C6.08083 1.3335 5.3335 2.0295 5.3335 2.8855V4.00016H2.66683H2.00016C1.6335 4.00016 1.3335 4.30016 1.3335 4.66683C1.3335 5.0335 1.6335 5.3335 2.00016 5.3335H2.66683V12.6668C2.66683 13.7695 3.56416 14.6668 4.66683 14.6668H11.3335C12.4362 14.6668 13.3335 13.7695 13.3335 12.6668V5.3335H14.0002C14.3668 5.3335 14.6668 5.0335 14.6668 4.66683C14.6668 4.30016 14.3668 4.00016 14.0002 4.00016Z"
        fill="#EB5757"
      />
    </svg>
  )
}

export default IconTrashSvg
